<template>
    <div>
        <q-table
            ref="table"
            :pagination.sync="server_pagination"
            :data="activities"
            :columns="columns"
            @request="requestActivities"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            hide-bottom
            class="shadow-0"
            v-if="$q.platform.is.desktop"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props" @click.native="showModal(props.row)" :class="getRowClass(props.row)">
                    <q-td key="type_title" :props="props">
                        {{ props.row.type_title }}
                    </q-td>

                    <q-td key="type_slug" :props="props">
                        <q-icon :name="getIcon(props.row.type_slug)" size="1rem" class="q-mr-sm" />
                        {{ $t(getType(props.row.type_slug)) }}
                    </q-td>

                    <q-td key="parent_id" :props="props">
                        {{ getParentTitle(props.row.parent_id) }}
                    </q-td>

                    <q-td key="avaliable_in" :props="props">
                        {{ fDate(props.row.avaliable_in) }}
                    </q-td>

                    <q-td key="score" :props="props">
                        {{ props.row.score > 0 ? props.row.score : '' }}
                    </q-td>

                    <q-td key="user_watch" :props="props" auto-width>
                        <q-icon name="fas fa-ban" size="1.5rem" color="negative" v-if="props.row.is_blocked" />
                        <q-icon name="far fa-clock" size="1.5rem" color="negative" v-else-if="props.row.is_expired" />
                        <q-icon name="far fa-check-circle" size="1.5rem" color="positive" v-else-if="props.row.user_watch || props.row.is_approved" />
                        <q-icon name="far fa-circle" size="1.5rem" color="primary" v-else />
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-card class="bg-grey-1 q-mt-md" v-for="(activity, index) in activities" :key="index" :class="getRowClass(activity)" >
            <q-card-main v-if="$q.platform.is.mobile" class="relative-position" @click.native="showModal(activity)">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm vertical-middle">
                    <div class="col-9">
                        <p>
                            <q-icon name="fas fa-ban" size="1rem" color="negative" v-if="activity.is_blocked" />
                            <q-icon name="far fa-check-circle" size="1rem" color="positive" v-else-if="activity.user_watch || activity.is_approved" />
                            <q-icon name="far fa-circle" size="1rem" color="primary" v-else />
                            <span class="q-ml-sm q-subheading">{{ activity.type_title }}</span>
                        </p>

                        <div v-if="activity.parent_id">
                            <p class="q-caption q-mb-xs">{{ $t('requirement') }}</p>
                            <p>{{ getParentTitle(activity.parent_id) }}</p>
                        </div>

                        <div v-if="activity.avaliable_in">
                            <p class="q-caption">{{ $t('avaliable_in') }} {{ fDate(activity.avaliable_in) }}</p>
                        </div>
                    </div>

                    <div class="col-3 text-right">
                        <q-icon :name="getIcon(activity.type_slug)" size="3rem" color="secondary" />
                    </div>
                </div>
            </q-card-main>

            <q-card-separator v-if="$q.platform.is.android && showOffline(activity)" />

            <!-- <q-card-actions v-if="$q.platform.is.android && $q.platform.is.cordova && showOffline(activity)">
                <q-btn flat icon="fas fa-download" color="primary" :label="$t(getButtonLabel(activity))" :color="getActivityCollor(activity)" @click="confirmDownloadModule(activity)" />
            </q-card-actions> -->
        </q-card>

        <q-card class="bg-grey-1 cursor-pointer" v-if="activities.length == 0">
            <q-card-main class="relative-position">
                <div class="line-card bg-primary absolute-top"></div>

                <div class="row gutter-sm">
                    <div class="col-12">
                        <p class="q-subheading">{{ $t('no_items_found') }}</p>
                    </div>
                </div>
            </q-card-main>
        </q-card>

        <q-modal v-model="show_modal" :content-css="{minWidth: '100vw', minHeight: '100vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar :style="{display: display}" slot="header">
                    <q-btn flat round dense @click="shouldHideModal()" icon="fas fa-times" v-if="type !== 'block_general_test' && type !== 'restart_general_test'" />
                    <q-toolbar-title>
                        {{ title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <course-video :activity="activity" :closing="closing" :display="display" v-if="type == 'video'" :key="id" @display='display=$event' @positionSent="closeModal()" />

                    <course-audio :activity="activity" :closing="closing" v-if="type == 'audio'" :key="id" @positionSent="closeModal()" />

                    <course-presentation :activity="activity" :closing="closing" :display="display"  v-if="type == 'pdf'" :key="id" @display='display=$event'  @positionSent="closeModal()" />

                    <course-youtube :activity="activity" :closing="closing" v-if="type == 'youtube'" :key="id" @positionSent="closeModal()" />

                    <course-vimeo :activity="activity" :closing="closing" v-if="type == 'vimeo'" :key="id" @positionSent="closeModal()" />

                    <course-slideshare :activity="activity" v-if="type == 'linkedin_slidshare'" :key="id" />

                    <course-scorm :activity="activity" v-if="type == 'scorm'" :key="id" />

                    <course-html :activity="activity" v-if="type == 'html'" :key="id" />

                    <power-point :activity="activity" v-if="type == 'ppt'" :key="id" />

                    <course-test :activity="activity" :closing="closing" v-if="type == 'restart_test' || type == 'block_test' || type == 'conventional_test' || type == 'evaluated_quiz' || type == 'unevaluated_quiz'" :key="id" @clearTest="closeModal()" />

                    <course-general-test :activity="activity" v-if="type === 'block_general_test' || type === 'restart_general_test'" :key="id" @closeTest="closeModal" />
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog
            v-model="confirm_remove_download"
            @ok="removeDownload()"
            @cancel="confirm_remove_download = false"
            >
            <span slot="title">{{ $t('remove_download') }}</span>

            <span slot="message">{{ $t('confirm_remove_the_download') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove_download = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeDownload()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CourseVideo from 'components/players/CourseVideo'
import CourseAudio from 'components/players/CourseAudio'
import CoursePresentation from 'components/players/CoursePresentation'
import CourseYoutube from 'components/players/CourseYoutube'
import CourseVimeo from 'components/players/CourseVimeo'
import CourseSlideshare from 'components/players/CourseSlideshare'
import CourseScorm from 'components/players/CourseScorm'
import CourseHTML from 'components/players/CourseHTML'
import CoursePpt from 'components/players/CoursePpt'
import CourseTest from 'components/course/ActivityTest'
import CourseGeneralTest from 'components/course/ActivityGeneralTest'
import websql from 'websql-promisified'
import { date } from 'quasar'
const { formatDate, getDateDiff } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    props: ['course'],

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            columns: [
                {
                    name: 'type_title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'type_title',
                    sortable: false,
                },
                {
                    name: 'type_slug',
                    required: true,
                    label: 'type_activity',
                    align: 'left',
                    field: 'type_slug',
                    sortable: false,
                },
                {
                    name: 'parent_id',
                    required: true,
                    label: 'requirement',
                    align: 'left',
                    field: 'parent_id',
                    sortable: false,
                },
                {
                    name: 'avaliable_in',
                    required: true,
                    label: 'avaliable_in',
                    align: 'left',
                    field: 'avaliable_in',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'user_watch',
                    required: true,
                    label: 'status',
                    align: 'center',
                    field: 'user_watch',
                    sortable: false,
                }
            ],
            activities: [],
            title: '',
            resource: '',
            id: '',
            type: '',
            activity: [],
            show_modal: false,
            closing: false,
            loading: false,
            activity_selected: [],
            confirm_remove_download: false,
            pdf_json: [],
            pdf_json_length: '',
            download_percentage: 0,
            display: 'flex',
            id_curse : '',
            id_trail: ''
        }
    },

    components: {
        'course-video': CourseVideo,
        'course-audio': CourseAudio,
        'course-presentation': CoursePresentation,
        'course-youtube': CourseYoutube,
        'course-vimeo': CourseVimeo,
        'course-slideshare': CourseSlideshare,
        'course-scorm': CourseScorm,
        'course-html': CourseHTML,
        'course-test': CourseTest,
        'course-general-test': CourseGeneralTest,
        'power-point': CoursePpt,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        requestActivities({ pagination }) {
            this.loading = true
            let new_activities = []
            this.selected_server_pagination = pagination
            this.$q.loading.show()

            let url = ''
            if (this.id_trail == "") {
                url = `/etraining_courses/group_training/${this.id_curse}/get_group_training_activities/`
            }
            else {
                url = `/etraining_trails/trail/${this.id_trail}/group_training/${this.id_curse}/get_group_training_activities/`
            }

            this.$axios.get(url, this.getHeader)
            .then(response => {
                response.data.forEach(group_training_activity => {
                    let activity = group_training_activity

                    if (group_training_activity.parent_id && group_training_activity.parent_slug == 'module') {
                        let obj = response.data.find((obj) => { return obj.type_id === activity.parent_id })

                        if (obj) activity.has_requirement = !obj.user_watch ? true : false
                        else activity.has_requirement = false
                    }
                    else if (group_training_activity.parent_id && group_training_activity.parent_slug == 'test') {
                        let obj = response.data.find((obj) => { return obj.type_id === activity.parent_id })

                        if (obj) activity.has_requirement = !obj.is_approved ? true : false
                        else activity.has_requirement = false
                    }
                    else {
                        activity.has_requirement = false
                    }
                        new_activities.push(activity)
                    // }
                })

                this.activities = new_activities

                this.loading = false
                this.$q.loading.hide()

                this.$emit('reloadActivity')
            })
            .catch(e => {
                this.loading = false
                if (this.$q.platform.is.mobile) this.$q.loading.hide()
                console.log(e)
            })
        },

        getType(slug) {
            switch(slug) {
                case 'pdf': return 'presentation'
                break
                case 'video': return 'video'
                break
                case 'audio': return 'audio'
                break
                case 'youtube': return 'youtube'
                break
                case 'vimeo': return 'vimeo'
                break
                case 'scorm': return 'scorm'
                break
                case 'html': return 'html'
                break
                case 'ppt': return 'PowerPoint'
                break
                case 'linkedin_slidshare': return 'slideshare'
                break
                case 'conventional_test': return 'conventional_test'
                break
                case 'block_test': return 'block_test'
                break
                case 'restart_test': return 'restart_test'
                break
                case 'evaluated_quiz': return 'evaluated_quiz'
                break
                case 'unevaluated_quiz': return 'unevaluated_quiz'
                break
                case 'block_general_test': return 'block_general_test'
                break
                case 'restart_general_test': return 'restart_general_test'
                break
            }
        },

        getIcon(slug) {
            switch(slug) {
                case 'pdf': return 'fas fa-chalkboard'
                break
                case 'video': return 'fas fa-video'
                break
                case 'audio': return 'fas fa-microphone-alt'
                break
                case 'youtube': return 'fab fa-youtube'
                break
                case 'vimeo': return 'fab fa-vimeo'
                break
                case 'scorm': return 'fas fa-chalkboard-teacher'
                break
                case 'html': return 'fas fa-code'
                break
                case 'ppt': return 'fas fa-chalkboard'
                break
                case 'linkedin_slidshare': return 'fab fa-slideshare'
                break
                case 'conventional_test':
                case 'restart_test':
                case 'restart_general_test':
                case 'block_general_test':
                case 'block_test': return 'fas fa-check-double'
                break
                case 'evaluated_quiz':
                case 'unevaluated_quiz': return 'far fa-check-square'
                break
            }
        },

        showModal(activity) {
            if (activity.downloading) return false

            if (activity.avaliable_in) {
                let date1 = moment(activity.avaliable_in).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS')
                let date2 = new Date()
                let unit = 'days'

                let diff = date.getDateDiff(date1, date2, unit)
                if (diff > 0) return false
            }

            if (!activity.has_requirement) {
                this.title = activity.type_title
                this.activity = activity
                this.id = activity.type_id
                this.type = activity.type_slug

                // if (!activity.is_offline) {
                    this.resource = activity.resource
                    this.show_modal = true
                // }
                // else {
                //     if (this.$q.platform.is.cordova) {
                //         var db = window.sqlitePlugin.openDatabase({name: 'training.db', location: 'default'})
                //         var websqlPromise = websql(db)

                //         websqlPromise.transaction((tr) => {
                //             tr.executeSql('SELECT * FROM ActivitiesFiles WHERE id_course = ? AND id_activity = ?', [this.course.id, activity.type_id], (tr, rs) => {
                //                 if(rs.rows.length > 0) {
                //                     this.resource = rs.rows.item(0).file_path
                //                     this.activity.resource = rs.rows.item(0).file_path
                //                 }
                //             })
                //         })
                //         .then((results) => {
                //             this.show_modal = true
                //         })
                //     }
                // }
            }
        },

        shouldHideModal() {
            let close_array = ['linkedin_slidshare', 'html', 'scorm', 'evaluated_quiz', 'unevaluated_quiz','ppt']

            if (close_array.includes(this.type)) this.closeModal()
            else this.closing = true
        },

        closeModal() {
            this.title = ''
            this.resource = ''
            this.activity = ''
            this.id = ''
            this.type = ''

            this.closing = false
            this.show_modal = false
            this.requestActivities({ pagination: this.server_pagination })
        },

        getParentTitle(parent_id) {
            let obj = this.activities.find((obj) => { return obj.type_id === parent_id })
            if (obj) return obj.type_title
            else return ''
        },

        getRowClass(activity) {
            if (activity.avaliable_in) {
                let date1 = moment(activity.avaliable_in).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS')
                let date2 = new Date()
                let unit = 'days'

                let diff = date.getDateDiff(date1, date2, unit)
                if (diff > 0) return 'blocked-activity text-faded'
            }

            if (activity.has_requirement) return 'blocked-activity text-faded'
            else return 'cursor-pointer'
        },

        showOffline(activity) {
            let types = ['video', 'pdf', 'audio']

            if (types.includes(activity.type_slug)) return true
            else return false
        },

        confirmDownloadModule(activity_selected) {
            this.activity_selected = activity_selected

            if (!this.activity_selected.downloading) {
                if (this.activity_selected.is_offline) {
                    this.confirm_remove_download = true
                }
                else {
                    if (this.$q.platform.is.android && this.$q.platform.is.cordova) {
                        if (navigator.connection.type != 'wifi') {
                            this.confirmDownloadNoWifi()
                        }
                        else {
                            this.selectDownloadType()
                        }
                    }
                }
            }
        },

        removeDownload() {
            // if (this.$q.platform.is.android && this.$q.platform.is.cordova) {
            //     var db = window.sqlitePlugin.openDatabase({name: 'training.db', location: 'default'})
            //     var websqlPromise = websql(db)

            //     websqlPromise.transaction((tr) => {
            //         tr.executeSql('SELECT * FROM ActivitiesFiles WHERE id_course = ? AND id_activity = ?', [this.course.id, this.activity_selected.type_id], (tr, rs) => {
            //             if(rs.rows.length > 0) {
            //                 window.resolveLocalFileSystemURL (rs.rows.item(0).file_path, (fileEntry) => {
            //                     fileEntry.remove(
            //                         () => {
            //                             this.$q.notify({
            //                                 message: this.$t('file_removed'),
            //                                 type: 'info',
            //                                 icon: 'fas fa-download'
            //                             })
            //                         },
            //                         (error) => {
            //                             console.log('Unable to remove file. ' + error)
            //                         }
            //                     )
            //                 })

            //                 tr.executeSql('DELETE FROM ActivitiesFiles WHERE id_course = ? AND id_activity = ?', [this.course.id, this.activity_selected.type_id])
            //             }
            //         })
            //     })
            //     .then((results) => {
            //         this.activity_selected.is_offline = false
            //         this.activity_selected.offline_path = ''
            //         this.confirm_remove_download = false
            //     })
            // }
        },

        confirmDownloadNoWifi() {
            this.selectDownloadType()
        },

        selectDownloadType() {
            if (this.activity_selected.type_slug === 'video' || this.activity_selected.type_slug === 'audio') {
                this.downloadVideoAudio()
            }
            else if (this.activity_selected.type_slug === 'pdf') {
                this.downloadPDF()
            }
        },

        downloadVideoAudio() {
            let uri_string = this.activity_selected.resource
            let notification_title = `${this.$t('downloading')} ${this.activity_selected.type_title}`
            let file_name = this.activity_selected.resource.substring(this.activity_selected.resource.lastIndexOf('/') + 1)

            window.resolveLocalFileSystemURL(cordova.file.externalDataDirectory, (dir_entry) => {
                dir_entry.getFile(file_name, { create: true }, (target_file) => {
                    let downloader = new BackgroundTransfer.BackgroundDownloader()
                    let download = downloader.createDownload(uri_string, target_file, notification_title)
                    let activity = this.activity_selected

                    activity.downloading = true

                    this.$q.notify({
                        message: this.$t('file_download_started'),
                        type: 'info',
                        icon: 'fas fa-download'
                    })

                    download.startAsync().then(
                        (e) => {
                            this.$q.notify({
                                message: this.$t('file_download_finished'),
                                type: 'positive',
                                icon: 'fas fa-download'
                            })

                            activity.is_offline = true
                            activity.downloading = false
                        },
                        (e) => {
                            this.$q.notify({
                                message: this.$t('file_download_fail'),
                                type: 'negative',
                                icon: 'fas fa-download'
                            })
                        },
                        (e) => {
                            // console.log(e)
                        }
                    )

                    this.saveToDB(this.course.id, this.activity_selected.type_id, target_file.nativeURL, activity)
                })
            })
        },

        downloadPDF() {
            let activity = this.activity_selected
            activity.downloading = true

            this.$axios.get(activity.resource)
            .then(response => {
                response.data.forEach(file => {
                    this.savePDF(file.file, file.seq, activity)
                })

                this.$q.notify({
                    message: this.$t('file_download_started'),
                    type: 'info',
                    icon: 'fas fa-download'
                })

                let new_json = []

                response.data.forEach(data => {
                    let file_name = data.file.substring(data.file.lastIndexOf('/') + 1)

                    new_json.push({
                        seq: data.seq,
                        file: `${cordova.file.externalDataDirectory}${activity.type_id}/${file_name}`
                    })
                })

                let data = JSON.stringify(new_json, null, '\t')
                let filename = activity.type_id + '.json'

                window.resolveLocalFileSystemURL(cordova.file.externalDataDirectory, (directory_entry) => {
                    directory_entry.getFile(filename, { create: true }, (file_entry) => {
                        file_entry.createWriter((file_writer) => {
                            file_writer.onwriteend = (e) => {
                                this.saveToDB(this.course.id, activity.type_id, file_entry.nativeURL, activity)
                            }

                            var blob = new Blob([data], { type: 'application/json' })
                            file_writer.write(blob)

                        }, () => {
                            console.log('Save file error')
                        })
                    }, () => {
                        console.log('Save file error')
                    })
                }, () => {
                    console.log('Save file error')
                })
            })
            .catch(e => {
                console.log(e)
            })
        },

        savePDF(file, seq, activity) {
            let uri_string = file
            let notification_title = `${this.$t('downloading')} ${activity.type_title}`
            let file_name = uri_string.substring(uri_string.lastIndexOf('/') + 1)

            window.resolveLocalFileSystemURL(cordova.file.externalDataDirectory, (root_directory) => {

                root_directory.getDirectory(activity.type_id.toString(), { create: true },  (dir_entry) => {

                    dir_entry.getFile(file_name, { create: true }, (target_file) => {
                        let downloader = new BackgroundTransfer.BackgroundDownloader()
                        let download = downloader.createDownload(uri_string, target_file, notification_title)

                        download.startAsync().then(
                            (e) => {
                                this.pdf_json.push({
                                    file: dir_entry.nativeURL,
                                    seq: seq
                                })
                            },
                            (e) => {
                                console.log(e)
                            },
                            (e) => {
                                // console.log(e)
                            }
                        )
                    })
                })
            })
        },

        saveToDB(course_id, activity_id, path, activity) {
            // var db = window.sqlitePlugin.openDatabase({name: 'training.db', location: 'default'})
            // var websqlPromise = websql(db)

            // websqlPromise.transaction((tr) => {
            //     tr.executeSql('INSERT INTO ActivitiesFiles VALUES (?,?,?)', [course_id, activity_id, path])
            // })
            // .then((results) => {
            //     activity.offline_path = path
            //     activity.is_offline = true
            //     activity.downloading = false
            // })
        },

        getButtonLabel(activity) {
            if (activity.is_offline) return 'avaliable_offline'
            else return 'download'
        },

        getActivityCollor(activity) {
            if (activity.is_offline) return 'positive'
            else return ''
        },

        initializeTables() {
            // if (this.$q.platform.is.android && this.$q.platform.is.cordova) {
            //     var db = window.sqlitePlugin.openDatabase({name: 'training.db', location: 'default'})
            //     var websqlPromise = websql(db)

            //     websqlPromise.transaction((tr) => {
            //         // tr.executeSql('DROP TABLE IF EXISTS Course')
            //         // tr.executeSql('DROP TABLE IF EXISTS Activities')
            //         // tr.executeSql('DROP TABLE IF EXISTS ActivitiesFiles')

            //         // tr.executeSql('CREATE TABLE IF NOT EXISTS Course (id_course, fields)')
            //         // tr.executeSql('CREATE TABLE IF NOT EXISTS Activities (id_activity, id_course, fields)')
            //         tr.executeSql('CREATE TABLE IF NOT EXISTS ActivitiesFiles (id_course, id_activity, file_path)')
            //     })
            // }
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return moment(d).tz('Etc/GMT').format(format)
            }
        }
    },

    created() {
        if(this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
        if(this.$route.params.id) this.id_curse = this.$route.params.id

        this.requestActivities({ pagination: this.server_pagination })
        this.initializeTables()
    },

    watch: {
        course: function() {
            this.server_pagination = {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            }

            if( this.$route.params.id_trail) this.id_trail = this.$route.params.id_trail
            if( this.$route.params.id) this.id_curse = this.$route.params.id

            this.requestActivities({ pagination: this.server_pagination })
            this.initializeTables()
        }
    }
}
</script>

<style lang="stylus" scoped>
.blocked-activity
    cursor not-allowed

.line-card
    border-top: 3px solid transparent
    border-top-left-radius inherit
    border-top-right-radius inherit
</style>
